import React, {useContext} from "react";
import {IonCard, IonCardContent, IonButton, IonRouterLink} from "@ionic/react";

import {useForm} from "react-hook-form";
import {Link, useHistory, useLocation} from "react-router-dom";

import {AuthContext} from "../../../context/AuthContext";
import {Breadcrumbs, Input} from "../../../components";

import {JWT_TOKEN} from "../../../constants/appConfig";

import toast from "react-hot-toast";

import "./login.styles.css";
import {getUserDetailsFromToken} from "../../../lib/utils/auth.utils";
import {
  clearLocalStorage,
  setLocalStorage,
} from "../../../lib/utils/storage.utils";

const Login = () => {
  const {loginMutation, setUser, cartList, refetchCartItems, addToCart} =
    useContext(AuthContext);
  const history = useHistory<{action?: string}>();
  const location = useLocation();

  const {
    handleSubmit,
    register,
    formState: {errors},
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
    },
  });

  const handleLogin = (data: any) => {
    loginMutation({
      variables: {
        email: data.username,
        password: data.password,
      },
    }).then((res: any) => {
      const data = res?.data?.customerLogin;
      const errors = data?.errors?.[0]?.message;

      if (errors) {
        toast.error(errors);
      } else {
        const userDetails: any = getUserDetailsFromToken(data?.token);
        setUser(userDetails);
        setLocalStorage(JWT_TOKEN, data?.token);

        cartList.forEach((item: any) => {
          addToCart(item.serviceID, item.serviceName, item.cartID);
        });

        clearLocalStorage("cos-milano-web-cart");
        refetchCartItems();

        // Get the redirect path from URL params if it exists
        const searchParams = new URLSearchParams(location.search);
        const richiamarePath = searchParams.get("richiamare");

        if (richiamarePath) {
          const decodedPath = decodeURIComponent(richiamarePath);
          let normalizedPath = decodedPath;
          if (!normalizedPath.startsWith("/")) {
            normalizedPath = `/${normalizedPath}`;
          }
          window.location.href = normalizedPath;
        } else if (history?.location?.state?.action === "updateCart") {
          window.location.href = "/personale/add-to-cart";
        } else {
          window.location.href = "/personale";
        }
      }
    });
  };

  const breadcrumbEntries = [{title: "Accedi o Registrati"}];

  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} />

      <div className="app-page-wrapper flex-center">
        <IonCard
          style={{
            width: "525px",
            padding: "20px",
          }}
        >
          <IonCardContent>
            <p
              className="card-title-text-large mb-default"
              style={{
                marginBottom: "20px",
              }}
            >
              Accedi o Registrati
            </p>

            <form onSubmit={handleSubmit(handleLogin)}>
              <Input
                name="Nome utente"
                registerName="username"
                register={register}
                errors={errors}
                requiredMessage="Campo obbligatorio"
                pattern={{
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                  message: "Indirizzo email non valido",
                }}
              />

              <Input
                name="Password"
                type="password"
                registerName="password"
                register={register}
                errors={errors}
                requiredMessage="Campo obbligatorio"
                pattern={{
                  value: /^.{8,}$/,
                  message: "La password deve essere lunga almeno 8 caratteri",
                }}
              />

              <div className="flex-justify-between">
                <IonRouterLink href="/forgot-password">
                  <p className="text-link">Password dimenticata?</p>
                </IonRouterLink>

                <IonButton
                  shape="round"
                  slot="end"
                  size="default"
                  className="login-button"
                  type="submit"
                >
                  Accedi
                </IonButton>
              </div>

              <div className="login-click-here">
                <span className="text-link">Non sei registrato?</span>
                <Link
                  to={{
                    pathname: `/register`,
                    state: {
                      previousLocation: "login",
                    },
                  }}
                >
                  <span className="colored-link">CLICCA QUI</span>
                </Link>
              </div>
            </form>
          </IonCardContent>
        </IonCard>
      </div>
    </div>
  );
};

export default Login;
